<img
  *ngIf="imagemComunicado"
  [src]="imagemComunicado"
  alt="Comunicado"
  (onerror)="desativarComunicado()"
  [style]="{ maxWidth: '100%' }"
/>
<div *ngFor="let categoria of categorias">
  <app-titulo [texto]="categoria.label"></app-titulo>
  <div class="lista">
    <ng-container *ngFor="let servico of categoria.servicos">
      <a
        *ngIf="servico.externo"
        [href]="servico.link"
        target="_blank"
        class="item"
      >
        <img [src]="servico.imagem" [alt]="servico.label" />
        <span [innerHTML]="servico.label | uppercase"></span>
      </a>

      <a *ngIf="!servico.externo" [routerLink]="servico.link" class="item">
        <img [src]="servico.imagem" [alt]="servico.label" />
        <span [innerHTML]="servico.label | uppercase"></span>
      </a>
    </ng-container>
  </div>
</div>
